const ALERT_MESSAGE = 'ALERT_MESSAGE'
const ALERT_MESSAGE_RESET = 'ALERT_MESSAGE_RESET'

const DEFAULT_TYPE = 'success'
const DEFAULT_DURATION = 1500
const DEFAULT_AUTO_CLOSE = true
const state = {
  message: '',
  type: DEFAULT_TYPE, // success, error
  duration: DEFAULT_DURATION, // 2500
  autoClose: DEFAULT_AUTO_CLOSE // true
}

const getters = {}

const mutations = {
  [ALERT_MESSAGE]: (state, data) => {
    state.message = data.message
    state.type = data.type ? data.type : DEFAULT_TYPE
    state.duration = data.duration ? data.duration : DEFAULT_DURATION
    state.autoClose = typeof (data.autoClose) === 'boolean' ? data.autoClose : DEFAULT_AUTO_CLOSE
  },
  [ALERT_MESSAGE_RESET]: state => {
    state.message = ''
    state.type = DEFAULT_TYPE
    state.duration = DEFAULT_DURATION
    state.type = DEFAULT_AUTO_CLOSE
  }
}

const actions = {}

export default {
  state,
  getters,
  actions,
  mutations
}
